export default __webpack_public_path__ + "static/media/zazmic-man.d78e4faa.png";